













import { Component, Mixins, Prop } from 'vue-property-decorator';
import DateMethods from '@/mixins/DateMethods.vue';
import EventLogMethods from '@/mixins/EventLogMethods.vue';
import moment from 'moment';

@Component({})

export default class EventLogItem extends Mixins(DateMethods, EventLogMethods) {
    @Prop() public logData!: any;

    constructor() {
        super();
    }
}
